export const EXPENSE_CATEGORY_EMOJIS = [
  {
    id: "transport",
    label: "Транспорт",
    icon: "🚗",
    emojis: [
      { char: "🚗", name: "Автомобиль" },
      { char: "🚕", name: "Такси" },
      { char: "🚙", name: "Внедорожник" },
      { char: "🚌", name: "Автобус" },
      { char: "🚎", name: "Троллейбус" },
      { char: "🏎️", name: "Гоночный автомобиль" },
      { char: "🚓", name: "Полицейская машина" },
      { char: "🚑", name: "Скорая помощь" },
      { char: "🚒", name: "Пожарная машина" },
      { char: "🚐", name: "Микроавтобус" },
      { char: "🚚", name: "Грузовик" },
      { char: "🚛", name: "Фура" },
      { char: "🚜", name: "Трактор" },
      { char: "🏗️", name: "Строительный кран" },
      { char: "🚲", name: "Велосипед" },
      { char: "🛵", name: "Скутер" },
      { char: "🏍️", name: "Мотоцикл" },
      { char: "✈️", name: "Самолёт" },
      { char: "🚀", name: "Ракета" },
      { char: "🚁", name: "Вертолёт" },
      { char: "⛵", name: "Парусная лодка" },
      { char: "🚢", name: "Корабль" },
      { char: "🛳️", name: "Паром" },
      { char: "🚂", name: "Поезд" },
      { char: "🚆", name: "Поезд" },
      { char: "🚇", name: "Метро" },
      { char: "⛽", name: "Заправка" },
      { char: "🅿️", name: "Парковка" },
      { char: "🛣️", name: "Дорога" },
      { char: "🛤️", name: "Путь" },
    ],
  },
  {
    id: "money",
    label: "Деньги и финансы",
    icon: "💰",
    emojis: [
      { char: "💰", name: "Деньги" },
      { char: "💵", name: "Доллары" },
      { char: "💶", name: "Евро" },
      { char: "💷", name: "Фунты" },
      { char: "💴", name: "Иены" },
      { char: "💳", name: "Банковская карта" },
      { char: "🏦", name: "Банк" },
      { char: "💹", name: "График роста" },
      { char: "📈", name: "График вверх" },
      { char: "📉", name: "График вниз" },
      { char: "🧾", name: "Чек" },
      { char: "🪙", name: "Монета" },
      { char: "💎", name: "Бриллиант" },
      { char: "🏧", name: "Банкомат" },
      { char: "💸", name: "Деньги с крыльями" },
      { char: "📊", name: "Диаграмма" },
      { char: "📋", name: "Документ" },
      { char: "🗂️", name: "Папки" },
      { char: "📁", name: "Папка" },
      { char: "📂", name: "Открытая папка" },
    ],
  },
  {
    id: "food",
    label: "Еда и напитки",
    icon: "🍔",
    emojis: [
      { char: "🍔", name: "Бургер" },
      { char: "🍕", name: "Пицца" },
      { char: "🌮", name: "Тако" },
      { char: "🌯", name: "Шаурма" },
      { char: "🥗", name: "Салат" },
      { char: "🍜", name: "Лапша" },
      { char: "🍱", name: "Ланч-бокс" },
      { char: "🥘", name: "Рагу" },
      { char: "🍲", name: "Суп" },
      { char: "🥙", name: "Питта" },
      { char: "🍛", name: "Карри" },
      { char: "🍝", name: "Паста" },
      { char: "☕", name: "Кофе" },
      { char: "🍵", name: "Чай" },
      { char: "🥤", name: "Напиток со льдом" },
      { char: "🧃", name: "Сок" },
      { char: "🍺", name: "Пиво" },
      { char: "🧁", name: "Капкейк" },
      { char: "🍰", name: "Торт" },
      { char: "🍩", name: "Пончик" },
    ],
  },
  {
    id: "tools",
    label: "Инструменты и работа",
    icon: "🔧",
    emojis: [
      { char: "🔧", name: "Гаечный ключ" },
      { char: "🔨", name: "Молоток" },
      { char: "⚙️", name: "Шестерёнка" },
      { char: "🛠️", name: "Инструменты" },
      { char: "⛏️", name: "Кирка" },
      { char: "🔩", name: "Болт" },
      { char: "🪛", name: "Отвёртка" },
      { char: "🪚", name: "Пила" },
      { char: "🔑", name: "Ключ" },
      { char: "🪝", name: "Крюк" },
      { char: "🧲", name: "Магнит" },
      { char: "💡", name: "Лампочка" },
      { char: "🔋", name: "Батарея" },
      { char: "🖥️", name: "Компьютер" },
      { char: "📱", name: "Телефон" },
      { char: "🖨️", name: "Принтер" },
      { char: "📡", name: "Антенна" },
      { char: "🔭", name: "Телескоп" },
      { char: "🧪", name: "Пробирка" },
      { char: "🧰", name: "Ящик с инструментами" },
    ],
  },
  {
    id: "buildings",
    label: "Здания и места",
    icon: "🏠",
    emojis: [
      { char: "🏠", name: "Дом" },
      { char: "🏢", name: "Офис" },
      { char: "🏭", name: "Завод" },
      { char: "🏗️", name: "Стройка" },
      { char: "🏪", name: "Магазин" },
      { char: "🏬", name: "Торговый центр" },
      { char: "🏨", name: "Отель" },
      { char: "🏥", name: "Больница" },
      { char: "🏦", name: "Банк" },
      { char: "🏫", name: "Школа" },
      { char: "⛪", name: "Церковь" },
      { char: "🏛️", name: "Колонны" },
      { char: "🗼", name: "Башня" },
      { char: "🗽", name: "Статуя" },
      { char: "🌆", name: "Город" },
      { char: "🌇", name: "Закат в городе" },
      { char: "🛒", name: "Тележка" },
      { char: "🗺️", name: "Карта" },
      { char: "📍", name: "Метка" },
      { char: "🚏", name: "Остановка" },
    ],
  },
  {
    id: "health",
    label: "Здоровье",
    icon: "💊",
    emojis: [
      { char: "💊", name: "Таблетка" },
      { char: "💉", name: "Укол" },
      { char: "🩺", name: "Стетоскоп" },
      { char: "🩹", name: "Пластырь" },
      { char: "🧬", name: "ДНК" },
      { char: "🦷", name: "Зуб" },
      { char: "🩻", name: "Рентген" },
      { char: "🏥", name: "Больница" },
      { char: "🚑", name: "Скорая" },
      { char: "🧴", name: "Лосьон" },
      { char: "🧼", name: "Мыло" },
      { char: "🪥", name: "Зубная щётка" },
      { char: "💆", name: "Массаж" },
      { char: "🏃", name: "Бег" },
      { char: "🧘", name: "Медитация" },
      { char: "🥗", name: "Здоровое питание" },
      { char: "❤️", name: "Сердце" },
      { char: "🩸", name: "Кровь" },
      { char: "😷", name: "Маска" },
      { char: "🤒", name: "Болезнь" },
    ],
  },
  {
    id: "other",
    label: "Разное",
    icon: "⭐",
    emojis: [
      { char: "⭐", name: "Звезда" },
      { char: "🎯", name: "Мишень" },
      { char: "🎁", name: "Подарок" },
      { char: "🎉", name: "Праздник" },
      { char: "📦", name: "Коробка" },
      { char: "📫", name: "Почта" },
      { char: "📌", name: "Кнопка" },
      { char: "🔖", name: "Закладка" },
      { char: "🏷️", name: "Ярлык" },
      { char: "🗑️", name: "Корзина" },
      { char: "📎", name: "Скрепка" },
      { char: "✂️", name: "Ножницы" },
      { char: "🖊️", name: "Ручка" },
      { char: "📝", name: "Блокнот" },
      { char: "📅", name: "Календарь" },
      { char: "⏰", name: "Будильник" },
      { char: "🌐", name: "Глобус" },
      { char: "🔔", name: "Колокольчик" },
      { char: "🚨", name: "Сигнализация" },
      { char: "🏆", name: "Трофей" },
    ],
  },
];
